import { useEffect, useState, useCallback } from "react";
import LoginForm from "./pages/Login";
import AdminPanel from "./pages/AdminPanel";
import { API_URL } from "./config/api.js";

const ALLOWED_ROLE_TYPES = ["owner", "admin"];

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("token"));

  const clearAuth = useCallback(() => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  }, []);

  const fetchAccount = useCallback(
    async (accessToken) => {
      try {
        const accountRes = await fetch(`${API_URL}/api/account`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
          },
        });

        if (!accountRes.ok) {
          throw new Error(`Account fetch failed: ${accountRes.status}`);
        }

        const accountData = await accountRes.json();
        const account = accountData?.data;

        if (!account) {
          throw new Error("Account data is empty");
        }

        const roleType = String(account?.role?.type || "").toLowerCase();

        if (!ALLOWED_ROLE_TYPES.includes(roleType)) {
          alert("Доступа нет");
          clearAuth();
          return;
        }

        setUser({
          id: account.id,
          name: account.name,
          surname: account.surname,
          email: account.email,
          phone: account.phone,
          status: account.status,

          org: account.org,
          role_id: account.role_id,
          role: account.role,
        });
      } catch (error) {
        console.error("Ошибка при получении аккаунта:", error);
        clearAuth();
      }
    },
    [clearAuth]
  );

  useEffect(() => {
    if (token) {
      fetchAccount(token);
    } else {
      setUser(null);
    }
  }, [token, fetchAccount]);

  const handleLogin = async (login, password) => {
    try {
      const res = await fetch(`${API_URL}/api/auth`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ login, password }),
      });

      if (!res.ok) {
        const errorText = await res.text();
        console.error("Ошибка авторизации:", errorText);
        alert("Неверный логин или пароль");
        return;
      }

      const data = await res.json();
      const accessToken = data?.data?.access_token;

      if (!accessToken) {
        console.error("access_token не найден в ответе:", data);
        alert("Ошибка авторизации: нет токена");
        return;
      }

      localStorage.setItem("token", accessToken);
      setToken(accessToken);
    } catch (error) {
      console.error("Ошибка авторизации:", error);
      alert("Ошибка авторизации. Проверьте логин и пароль.");
    }
  };

  const handleLogout = async () => {
    const accessToken = localStorage.getItem("token");

    try {
      if (accessToken) {
        await fetch(`${API_URL}/api/account/logout`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
          },
        });
      }
    } catch (error) {
      console.error("Ошибка при logout (можно игнорировать):", error);
    } finally {
      clearAuth();
    }
  };

  if (user) {
    return <AdminPanel user={user} onLogout={handleLogout} />;
  }

  return <LoginForm onLogin={handleLogin} />;
}

export default App;
